import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../cart/services/store';
import { productsActions } from '../products/actions';
import IconAddToBag from '../products/components/icon_add_to_bag/IconAddToBag';

window.store = window.store || store;

// Each Icons add-to-bag button is mounted by react_component with
// id="react-icons-add-to-bag-<productId>" and a sibling
// script[data-dom-id="<id>"] JSON tag carrying the serialized product.
function hydrateIconsButtons() {
  const containers = document.querySelectorAll('[id^="react-icons-add-to-bag-"]');

  containers.forEach((container) => {
    const dataTag = document.querySelector(`script[data-dom-id="${container.id}"]`);
    if (!dataTag) { return; }

    try {
      const product = JSON.parse(dataTag.textContent);
      window.store.dispatch(productsActions.addProducts([product]));

      hydrateRoot(
        container,
        <Provider store={window.store}>
          <IconAddToBag product={product} />
        </Provider>,
      );
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Failed to hydrate Icons add-to-bag button for ${container.id}:`, e);
    }
  });
}

document.addEventListener('DOMContentLoaded', hydrateIconsButtons);
